import { render, staticRenderFns } from "./PrescriptionDetailed.vue?vue&type=template&id=606cf6f2&"
import script from "./PrescriptionDetailed.vue?vue&type=script&lang=js&"
export * from "./PrescriptionDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports